import { ReactNode } from "react";
import Config from "config/config";
import TipsLayout from "context/tips";
import Cookies from "js-cookie";
import CustomImage from "components/common/CustomImage";
import Tools from "libs/utils/Tools";

export default function AuthLayout(props: {children: ReactNode}){

    const flag = !!Cookies.get('Authorization')
    if(flag && /(signup|login)/ig.test(location.href)){
        location.href = Tools.disponseUrl('/')
    }

    return (
        <TipsLayout>
            <div className="w-full min-h-screen flex flex-col bg-[#F4F4F4]">
                <header className="flex h-[60px] xl:h-[80px] bg-[#FFFFFF]">
                    <div className='flex items-center justify-center flex-none w-[230px] '>
                        <a href={Config.websiteUrl}><CustomImage src="/logo.png" className=" h-[57px] cursor-pointer"/></a>
                    </div>
                </header>
                <div className="flex grow w-full justify-center mt-[40px]">
                    { props.children }
                </div>
            </div>
        </TipsLayout>
    )
}